<ng-sidebar-container>
    <ng-sidebar #sidebar [(mode)]="sidebarMode" [(opened)]="isSidebarOpen">
        <frontsidebar
            (onSidebarLoaded)="refreshSidebar()"
            (onSidebarToggle)="toggleSidebar()"
            [nurseries]="nurseries"
            [isInsideNursery]="false"
            [isInsidePhotosphere]="false"
            [isBack]="null"
        ></frontsidebar>
    </ng-sidebar>

    <div ng-sidebar-content class="h-100">
        <div class="container-fluid p-0 h-100 position-relative">
            <agm-map
                class="h-80 rounded"
                [disableDoubleClickZoom]="true"
                [disableDefaultUI]="true"
                [zoomControl]="true"
                [latitude]="avgLat"
                [longitude]="avgLong"
                [zoom]="zoom"
                [mapTypeId]="'hybrid'"
                (mapReady)="initDrawManager($event)"
                [styles]="mapStyle"
            >
            </agm-map>

            <button
                class="btn"
                (click)="toggleSidebar()"
                style="position: absolute; top: 0; left: 0; background: white; border-radius: 0;"
            >
                <i class="fas fa-bars"></i>
            </button>

            <nursery-carousel class="w-100 h-20" [nurseries]="nurseries" [promotions]="promotions"></nursery-carousel>
        </div>
    </div>
</ng-sidebar-container>
